import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareX = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler55') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler55', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Zulrah drop*!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Zulrah drop*!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareX}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareX
  
